import { Component } from 'react'
import { withRouter } from 'react-router'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname === '/' && this.props.location.pathname !== '/') {
      //ugly fix for slideshow scroll
      setTimeout(()=>window.scrollTo({
        top: 0,
        behavior: "smooth"
      }), 500)
    }
    else if (
      this.props.location !== prevProps.location &&
      this.props.location.hash === '' && prevProps.location.hash === '' && 
      (prevProps.location.pathname.substring(0,8) !== this.props.location.pathname.substring(0,8) ||
        (prevProps.location.pathname.indexOf('trainingen') !== -1 && this.props.location.pathname.indexOf('trainingen') !== -1 )
      )
    ){
    	 window.scrollTo({
  	    top: 0,
  	    behavior: "smooth"
		  })
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)


// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js